import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
//Components
import {Typography,} from '@material-ui/core';
import Box from "@material-ui/core/Box";
//Img
//Actions

const useStyles = makeStyles(theme => ({
    typographyLanguage: {
        maxWidth: "500px",
        width: "100%",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        "& p": {
            padding: "0px",
            margin: "0px",
            display: "inline"
        }
    }
}));

export default function ProductLanguagePreview(props) {
    const classes = useStyles();
    const {productLanguage, language} = props;

    return (
        <Typography variant={"caption"} className={classes.typographyLanguage}>
            <Box display={"flex"} flexDirection={"row"}>
                {language ? language.unicodeIcon : ""}
                <Box display={"flex"} flexDirection={"column"}>
                    <div dangerouslySetInnerHTML={{__html: productLanguage.nameProduct}}></div>
                </Box>
            </Box>
        </Typography>
    );
}
